import { useTranslation } from "react-i18next";
import type { SparkQuestion } from "@/hooks/useSparkQuestion";
import type { RecordingOpts } from "@/components/HomeFeed";
import {
  CARD_COLORS,
  cardShellStyle,
  fullCtaStyle,
  labelStyle,
  titleStyle,
} from "./types";

interface SparkCardProps {
  spark: SparkQuestion;
  onRecord: (opts?: RecordingOpts) => void;
}

const SparkCard = ({ spark, onRecord }: SparkCardProps) => {
  const { t } = useTranslation();
  const colors = CARD_COLORS.spark;

  return (
    <div style={cardShellStyle(colors.bg, colors.border)}>
      {/* Top: label + question */}
      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div style={labelStyle(colors.body)}>{t("cards.spark.label")}</div>

        <p
          style={{
            ...titleStyle(colors.title),
            marginTop: 8,
            display: "-webkit-box",
            WebkitLineClamp: 7,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            flex: 1,
          }}
        >
          {spark.question}
        </p>
      </div>

      {/* Bottom: CTA */}
      <div style={{ paddingTop: 12 }}>
        <button
          type="button"
          onClick={() => onRecord({ contextPrompt: spark.question })}
          style={fullCtaStyle(colors.title, colors.bg)}
        >
          {t("cards.spark.cta")}
        </button>
      </div>
    </div>
  );
};

export default SparkCard;
